<template>
    <div class="teacher-course-index" v-loading="loading">
        <div class="model-header">
            <h3 class="user-title-main">Cập nhật đề thi</h3>
            <el-button @click="backModel" size="small" type="info" class="btn-create">Trở về khóa học</el-button>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="Thông tin" name="first">
                <el-form label-position="top" :rules="rulesTestKit" :model="modelLessonTestKitUpdate" ref="updateModelTestKit">
                  <el-row :gutter="12">
                    <el-col :span="16">
                      <el-row :gutter="10">
                        <el-col :span="12">
                          <el-form-item prop="test_kit_type_time" label="Kiểu đề thi" class="form-item">
                            <el-select v-model="modelLessonTestKitUpdate.test_kit_type_time" filterable placeholder="Kiểu đề thi" class="input-select">
                              <el-option
                                v-for="item in lists.listTypeTime"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item prop="test_kit_time" label="Thời gian thi" class="form-item">
                            <el-input v-model="modelLessonTestKitUpdate.test_kit_time" class="input-seach input-seach-2">
                              <template slot="append">{{ modelLessonTestKitUpdate.test_kit_time }} phút</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="test_kit_type_question" label="Loại đề thi" class="form-item">
                            <el-select disabled v-model="modelLessonTestKitUpdate.test_kit_type_question" filterable placeholder="Loại đề thi" class="input-select">
                              <el-option
                                v-for="item in lists.listTypeQuesition"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item prop="test_kit_score_success" label="Điểm đạt tối thiểu" class="form-item">
                            <el-select v-model="modelLessonTestKitUpdate.test_kit_score_success" filterable placeholder="Điểm đạt" class="input-select">
                              <el-option
                                v-for="item in lists.listScoreSuccess"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-form-item prop="test_kit_name" label="Tên đề thi" class="form-item">
                        <el-input v-model="modelLessonTestKitUpdate.test_kit_name" class="input-seach" clearable></el-input>
                      </el-form-item>
                      <el-form-item prop="test_kit_content" label="Tài liệu đề thi" v-if="canUpdate">
                        <tinymce
                          id="d112"
                          v-model="modelLessonTestKitUpdate.test_kit_content"
                          :toolbar1="tinymce.toolbar1"
                          :other_options="{ height: '300px', language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
                      </el-form-item>
                      <label>
                        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                      </label>
                      <el-button v-on:click="submitFile()" size="mini" type="success">
                          <i class="fas fa-spinner fa-spin" v-if="uploadProcess"></i>
                          Gửi
                      </el-button>
                      <p>{{ link }}</p>
                    </el-col>
                  </el-row>
                  <el-form-item>
                    <el-button
                      :disable="!canSubmit"
                      :loading="!canSubmit"
                      type="warning"
                      size="small"
                      @click="submitFormUpdateTestKit('updateModelTestKit')">Cập nhật</el-button>
                  </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="Danh sách câu hỏi" name="second">
                <div class="course-terms">
                    <div
                        class="item-child-2 d-flex flex-sm-row justify-content-between"
                        v-for="(item2, index) in questionOption">
                        <span>
                            <strong>Câu {{ index + 1 }} : <span  v-html="item2.text"></span></strong>
                        </span>
                        <div class="d-flex align-items-center">
                            <div class="module-action">
                                <el-tooltip effect="dark" content="Sửa" placement="top">
                                  <span @click="updateModelQuestion(item2)">
                                    <i class="far fa-edit icon-update"></i>
                                  </span>
                                </el-tooltip>
                                <el-tooltip effect="dark" content="Xóa" placement="top">
                                    <span @click="confirmDeleteModelLesson(item2)">
                                        <i class="far fa-trash-alt icon-delete"></i>
                                    </span>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <el-button @click="addQuestion" size="small" type="info" class="btn-create">Thêm câu hỏi</el-button>
                    <el-button @click="showImportExcel" size="small" type="info" class="btn-create">Import file excel</el-button>
                </div>
            </el-tab-pane>
        </el-tabs>

        <el-dialog
            :close-on-click-modal="false"
            :title="'Thêm mới câu hỏi'"
            :visible.sync="dialogVisibleQuesionCreate"
            top="15vh"
            :width="isMobile()">
            <div>
              <el-form label-position="top" :rules="rulesQuestionCreate" :model="modelQuesionCreate" ref="createModelQuestion">
                <el-form-item prop="text" label="Nội dung câu hỏi" class="form-item">
                  <el-input v-model="modelQuesionCreate.text" type="textarea" :rows="3" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="radio" class="form-item" v-if="testkit.test_kit_type_question == 1">
                  <el-row :gutter="20">
                    <div v-for="option in modelQuesionCreate.options" :key="option.id">
                      <el-col :span="12">
                        <el-row :gutter="10">
                          <el-col :span="20">
                            <el-form-item :label="'Câu trả lời ' + option.id" class="form-item">
                              <el-input v-model="option.text" type="textarea" :rows="2" class="input-seach"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="4">
                            <el-form-item label="Đáp án" class="form-item">
                              <el-switch
                                active-color="#13ce66"
                                inactive-color="#7f8c8d"
                                v-model="option.is_answer">
                              </el-switch>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </div>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-button
                    :disable="!canSubmit"
                    :loading="!canSubmit"
                    type="success"
                    size="small"
                    @click="submitFormQuestion('createModelQuestion')">Lưu lại</el-button>
                </el-form-item>
              </el-form>
            </div>
        </el-dialog>

        <el-dialog
            :close-on-click-modal="false"
            :title="'Cập nhật câu hỏi'"
            :visible.sync="dialogVisibleQuesionUpdate"
            top="15vh"
            :width="isMobile()">
            <div>
              <el-form label-position="top" :rules="rulesQuestionCreate" :model="modelQuesionUpdate" ref="updateModelQuestion">
                <el-form-item prop="text" label="Nội dung câu hỏi" class="form-item">
                  <el-input v-model="modelQuesionUpdate.text" type="textarea" :rows="3" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="radio" class="form-item" v-if="testkit.test_kit_type_question == 1">
                  <el-row :gutter="20">
                    <div v-for="(option, index) in modelQuesionUpdate.options" :key="option.id">
                      <el-col :span="12">
                        <el-row :gutter="10">
                          <el-col :span="20">
                            <el-form-item :label="'Câu trả lời ' + (index + 1)" class="form-item">
                              <el-input v-model="option.text" type="textarea" :rows="2" class="input-seach"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="4">
                            <el-form-item label="Đáp án" class="form-item">
                              <!-- <el-radio v-model="modelQuesionUpdate.radio" :label="option.id">{{ (index + 1) }}</el-radio> -->
                              <el-switch
                                active-color="#13ce66"
                                inactive-color="#7f8c8d"
                                v-model="option.is_answer">
                              </el-switch>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </div>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-button
                    :disable="!canSubmit"
                    :loading="!canSubmit"
                    type="warning"
                    size="small"
                    @click="submitFormUpdateQuestion('updateModelQuestion')">Cập nhật</el-button>
                </el-form-item>
              </el-form>
            </div>
        </el-dialog>


        <el-dialog
            :close-on-click-modal="false"
            :title="'Import Word'"
            :visible.sync="importExcel.showDialog"
            top="5vh"
            width="65%">
            <div>
              <div class="updatSeting">
                <el-row>
                  <div class="model-header setting">
                    <h2>Test Upload File Docx</h2>
                    <div>
                      <a class="item-link" href="https://demo.hn.ss.bfcplatform.vn/docx/getmarked-practice-0v2.docx" target="_blank">File Cộng hòa Xã hội mẫu</a>
                      <a class="item-link" href="https://demo.hn.ss.bfcplatform.vn/docx/dethimau.docx" target="_blank">File Docx mẫu</a>
                    </div>
                  </div>
                </el-row>
                <el-row>
                  <div class="pt-2">
                      <label>
                        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                      </label>
                      <el-button v-on:click="submitFile()" size="mini" type="success">
                          <i class="fas fa-spinner fa-spin" v-if="importExcel.uploadProcess"></i>
                          Gửi file Docx
                      </el-button>
                  </div>
                  <div style="padding-top: 20px" v-if="importExcel.loadingQuizDoc">
                    <span>Hệ thống đang thực hiện chuyển đổi file docx. Vui lòng chờ 2-3 phút để hoàn tất ...</span>
                  </div>
                  <div style="padding-top: 20px" v-if="importExcel.loadingQuizDoc == false && importExcel.questions.length">
                    <h2>Danh sách câu hỏi của File Docx vừa upload:</h2>
                  </div>
                  <div class="list-question" v-loading="importExcel.loadingQuizDoc">
                    <div class="item-question"
                      :key="item.id"
                      v-for="(item, index) in importExcel.questions">
                      <div class="content-question">
                        <strong class="index">Câu {{ index + 1 }}: </strong>
                        <div v-html="item.text"></div>
                      </div>
                      <div>
                        <div class="d-flex item-option" v-for="option in item.options" :key="option.id">
                          <el-switch
                            active-color="#13ce66"
                            inactive-color="#7f8c8d"
                            v-model="option.is_answer">
                          </el-switch>
                          <span class="content-option" v-html="option.text"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-row>
              </div>
              <div>
                  <el-button
                    :disable="!importExcel.canSubmit"
                    :loading="!importExcel.canSubmit"
                    type="success"
                    size="small"
                    @click="confirmSaveMultiple">Lưu list câu hỏi vừa Import</el-button>
                </el-form-item>
              </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
  import axios from 'axios'
  import { head } from 'lodash'
    import { mapActions, mapGetters } from 'vuex'
    import draggable from 'vuedraggable'
    import tinymce from 'vue-tinymce-editor'
    export default {
        name: 'TeacherTestKitUpdate',
        props: {
            params: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            courseID: {
                type: Number,
                default: 0
            },
            testkit: {
                type: Object,
                default: () => {
                    return {};
                }
            },
        },
        components: {
          draggable,
          tinymce
        },
        computed: {
            dragOptions() {
              return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
              };
            }
        },
        data () {
            return {
                drag: false,
                loading: false,
                canSubmit: true,
                canUpdate: true,
                activeName: 'first',

                // FILE
                file: {},
                link: '',
                uploadProcess: false,

                status: true,
                modelData: {

                },

                questionOption: [],

                // Phần cập nhật thông tin đề đề thi
                modelLessonTestKitUpdate: {

                },
                rulesTestKit: {
                    name: [
                      { required: true, message: 'Vui lòng nhập tên đề thi' },
                      { min: 2, max: 191, message: 'Tên đề thi có chiều dài từ 2 tới 191 kí tự' }
                    ],
                    time: [
                      { required: true, message: 'Vui lòng nhập thời gian thi' }
                    ]
                },

                // Phần tạo mới câu hỏi
                dialogVisibleQuesionCreate: false,
                modelQuesionCreate: {
                    text: '',
                    lesson_id: '',
                    type_question: 1,
                    radio: '',
                    options: [
                      {
                        id: 1,
                        text: '',
                        is_answer: false
                      },
                      {
                        id: 2,
                        text: '',
                        is_answer: false
                      },
                      {
                        id: 3,
                        text: '',
                        is_answer: false
                      },
                      {
                        id: 4,
                        text: '',
                        is_answer: false
                      }
                    ],
                    status: true
                },
                rulesQuestionCreate: {
                    text: [
                      { required: true, message: 'Vui lòng nhập nội dung câu hỏi' }
                    ],
                    radio: [
                      { required: false, message: 'Vui lòng chọn đáp án' }
                    ]
                },

                // Phần tạo mới câu hỏi
                dialogVisibleQuesionUpdate: false,
                modelQuesionUpdate: {

                },

                // Phần cập nhật đề thi
                lists: {
                  listCategoryCourse: [
                    {key: 0, value: 'Chọn lĩnh vực'}
                  ],
                  listTeacher: [
                    {key: 0, value: 'Chọn giảng viên'}
                  ],
                  listUniversity: [
                    {key: 0, value: 'Không thuộc trường nào'},
                    {key: 1, value: 'Trường Học Viện Ngân Hàng'},
                    {key: 2, value: 'Trường Kinh Tế Quốc Dân'}
                  ],
                  listRank: [
                    {key: 0, value: 'Chưa xếp hạng'},
                    {key: 1, value: 'Người mới học'},
                    {key: 2, value: 'Trung bình'},
                    {key: 3, value: 'Nâng cao'}
                  ],
                  listTypeCourse: [
                    {key: 0, value: 'Khóa học kĩ năng'},
                    {key: 1, value: 'Khóa học đào tạo'}
                  ],
                  listSchool: [],
                  listLevel: [],
                  listFacult: [],
                  listSpecialized: [],
                  listTypeTime: [
                    {key: 1, value: 'Kiểm tra 15 phút'},
                    {key: 12, value: 'Kiểm tra giữa môn học'},
                    // {key: 13, value: 'Kiểm tra giữa môn'},
                    {key: 14, value: 'Kiểm tra kết thúc môn'},
                    {key: 15, value: 'Kiểm tra cuối ky'},
                    {key: 16, value: 'Thi Tốt Nghiệp'},
                    {key: 17, value: 'Khóa luận tốt nghiệp'},
                    {key: 18, value: 'Kiểm tra đầu vào'},
                    {key: 19, value: 'Kiểm tra cuối bài'},
                    {key: 20, value: 'Kiểm tra đánh giá năng lực'},
                    {key: 21, value: 'Đề thi lý thuyết'}
                  ],
                  listTypeQuesition: [
                    {key: 1, value: 'Trắc nghiệm'},
                    {key: 2, value: 'Tự luận'}
                  ],
                  listScoreSuccess: [
                    {key: 0, value: '0 điểm'},
                    {key: 0.5, value: '0,5 điểm'},
                    {key: 1, value: '1 điểm'},
                    {key: 1.5, value: '1.5 điểm'},
                    {key: 2, value: '2 điểm'},
                    {key: 2.5, value: '2.5 điểm'},
                    {key: 3, value: '3 điểm'},
                    {key: 3.5, value: '3.5 điểm'},
                    {key: 4, value: '4 điểm'},
                    {key: 4.5, value: '4.5 điểm'},
                    {key: 5, value: '5 điểm'},
                    {key: 5.5, value: '5.5 điểm'},
                    {key: 6, value: '6 điểm'},
                    {key: 6.5, value: '6.5 điểm'},
                    {key: 7, value: '7 điểm'},
                    {key: 7.5, value: '7.5 điểm'},
                    {key: 8, value: '8 điểm'},
                    {key: 8.5, value: '8.5 điểm'},
                    {key: 9, value: '9 điểm'},
                    {key: 9.5, value: '9.5 điểm'},
                    {key: 10, value: '10 điểm'}
                  ]
                },
                upload: {
                  uploadProcess: false,
                  url: '',
                  headers: {
                    Authorization: ''
                  }
                },
                tinymce: {
                  toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
                },
                rules: {
                    name: [
                      { required: true, message: 'Vui lòng nhập tên khóa học' },
                      { min: 2, max: 191, message: 'Tên khóa học có chiều dài từ 2 tới 191 kí tự' }
                    ],
                    price: [
                      { required: true, message: 'Vui lòng nhập giá khóa học' },
                      { type: 'number', message: 'Giá khóa học phải là kiểu số' }
                    ],
                    category_course_id: [
                      { required: true, message: 'Vui lòng nhập lĩnh vực khóa học' }
                    ],
                    content: [
                      { required: true, message: 'Vui lòng nhập mô tả khóa học' }
                    ]
                },

                // Import Ecxcel,
                importExcel: {
                  showDialog: false,

                  canSubmit: true,
                  loadingQuizDoc: false,
                  link_quiz: 'https://digitaliser.getmarked.ai/api/v1.0/job/6340/',
                  inteval: {},
                  questions: [],

                  // FILE
                  file: {},
                  uploadProcess: false
                }
            }
        },
        mounted() {
            this.configFilter();
            this.fetchQuestionOption()
            // this.modelLessonTestKitUpdate = this.testkit;
            this.modelQuesionCreate.test_kit_id = this.testkit.test_kit_id

            setTimeout(() => {
              this.modelLessonTestKitUpdate = this.testkit;
            }, 1000)
        },
        methods: {
          handleFileUpload () {
            this.file = this.$refs.file.files[0]
          },
            async submitFile () {
              this.uploadProcess = true;
              let formData = new FormData()
              formData.append('file', this.file)
              formData.append('lesson_id', this.modelLessonTestKitUpdate.lesson_id)
              let response = await axios.post('test-kits/upload-to-s3', formData)
              this.uploadProcess = false;
              if (response.code == 1) {
                  this.link = response.data.path
                  this.$notify({
                      title: 'Thành công',
                      message: 'Gửi file thành công',
                      type: 'success'
                  });
              } else {
                  this.$notify({
                      title: 'Có lỗi xảy ra',
                      message: 'File không đúng định dạng hoặc dung lượng quá 2Mb',
                      type: 'warning'
                  });
              }
            },
            configFilter () {
              this.courseID = this.$route.params.course_id
            },
            backModel () {
                this.$emit('selectType', 'update')
                this.$emit('selectTabCourseUpdate', 'second');
            },
            handleClick () {

            },
            isMobile() {
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return '96%'
                } else {
                    return '50%'
                }
            },
            ...mapActions(['setBreadcrumb']),
            configBreadcrumb () {
              let breadcrumb = [
                { name: 'home-index', text: 'Trang chủ' },
                { name: 'courses-index', text: 'Khóa học' },
                { name: 'courses-update-v2', course_id: this.modelData.id, text: this.modelData.name },
                { name: '1courses-update1', text: this.testkit.name}
              ]
              this.setBreadcrumb(breadcrumb)
            },
            fetchModel () {
                this.canSubmit = false
                axios.get('courses/' + this.courseID).then(response => {
                  switch (response.code) {
                    case 200:
                      this.canSubmit = true
                      this.modelData = response.data
                      this.configBreadcrumb();
                      break
                    default:
                      this.$notify.error({
                        title: 'Error',
                        message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                      })
                      break
                  }
                })
            },
            fetchQuestionOption () {
                axios.post('test-kits/get-question-option/' + this.testkit.test_kit_id).then(response => {
                  switch (response.code) {
                    case 200:
                      this.canSubmit = true
                      this.questionOption = response.data.questions
                      this.fetchModel()
                      break
                    default:
                      this.$notify.error({
                        title: 'Error',
                        message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                      })
                      break
                  }
                })
            },

            // Upload Ảnh
            beforeAvatarUpload (file) {
              const isLt2M = file.size / 1024 / 1024 < 2

              if (!isLt2M) {
                this.$message.error('Ảnh khóa học có dung lượng ảnh tối đa là 2M')
              }
              return isLt2M
            },
            handleAvatarSuccess (response) {
              this.upload.uploadProcess = false
              if (response.code) {
                this.modelData.image = response.data.name
                this.modelData.image_path = response.data.path_sm
              }
            },
            handleAvatarProcess (event, file, fileList) {
              this.upload.uploadProcess = true
            },

            // Phần câu hỏi
            addQuestion () {
                this.dialogVisibleQuesionCreate = true;
            },
            submitFormQuestion (formName) {
                this.$refs[formName].validate((valid) => {
                  if (valid) {
                    this.submitFormQuestionAction();
                  } else {
                    this.$notify({
                      title: 'Lỗi dữ liệu nhập',
                      message: 'Vui lòng kiểm tra lại thông tin',
                      type: 'warning'
                    })
                    return false
                  }
                })
            },
            submitFormQuestionAction () {
                this.canSubmit = false
                if (this.testkit.test_kit_type_question === 2) {
                    delete this.modelQuesionCreate['options']
                }

                let count = 0;
                if (this.testkit.test_kit_type_question === 1) {
                    _.forEach(this.modelQuesionCreate['options'], (item, index) => {
                        if (item.is_answer === true) {
                            count += 1;
                        }
                    });

                    if (count == 0) {
                        this.$notify({
                            title: 'Thông báo',
                            message: 'Bạn chưa chọn đáp án cho câu hỏi',
                            type: 'warning'
                        });
                        this.canSubmit = true;
                        return
                    }
                }


              axios.post('questions', this.modelQuesionCreate).then(response => {
                this.canSubmit = true
                    switch (response.code) {
                      case 200:
                        this.$notify({
                          title: 'Thành công',
                          message: 'Thêm thành công',
                          type: 'success',
                          duration: '1000'
                        })
                        this.modelQuesionCreate.text = '';
                        this.$refs['createModelQuestion'].resetFields();

                        if (this.testkit.test_kit_type_question === 1) {
                            this.modelQuesionCreate.options[0].text = ''
                            this.modelQuesionCreate.options[1].text = ''
                            this.modelQuesionCreate.options[2].text = ''
                            this.modelQuesionCreate.options[3].text = ''

                            this.modelQuesionCreate.options[0].is_answer = false
                            this.modelQuesionCreate.options[1].is_answer = false
                            this.modelQuesionCreate.options[2].is_answer = false
                            this.modelQuesionCreate.options[3].is_answer = false
                            this.modelQuesionCreate.radio = ''
                        }

                        this.fetchQuestionOption();
                        break
                      case 422:
                        let er = response.data.errors
                        let message = _.head(er[Object.keys(er)[0]])
                        this.$notify({
                          title: 'Có lỗi xảy ra',
                          message: message,
                          type: 'warning'
                        })
                        break
                      default:
                        this.$notify.error({
                          title: 'Error',
                          message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                        })
                        break
                    }
              });
            },


            updateModelQuestion (model) {
                this.dialogVisibleQuesionUpdate = true;
                this.modelQuesionUpdate = model;
            },
            submitFormUpdateQuestion (formName) {
                this.$refs[formName].validate((valid) => {
                  if (valid) {
                    this.submitFormUpdateQuestionAction();
                  } else {
                    this.$notify({
                      title: 'Lỗi dữ liệu nhập',
                      message: 'Vui lòng kiểm tra lại thông tin',
                      type: 'warning'
                    })
                    return false
                  }
                })
            },

            submitFormUpdateQuestionAction () {
                this.canSubmit = false

                let count = 0;
                if (this.testkit.test_kit_type_question === 1) {
                    _.forEach(this.modelQuesionUpdate['options'], (item, index) => {
                        if (item.is_answer === true) {
                            count += 1;
                        }
                    });

                    if (count == 0) {
                        this.$notify({
                            title: 'Thông báo',
                            message: 'Bạn chưa chọn đáp án cho câu hỏi',
                            type: 'warning'
                        });
                        this.canSubmit = true;
                        return
                    }
                }

                axios.put('questions/' + this.modelQuesionUpdate.question_id, this.modelQuesionUpdate).then(response => {
                    this.canSubmit = true
                    switch (response.code) {
                        case 200:
                            this.$notify({
                                title: 'Thành công',
                                message: 'Cập nhật chương mới thành công',
                                type: 'success',
                                duration: '1000'
                            })
                            this.fetchQuestionOption();
                        break
                        case 422:
                            let er = response.data.errors
                            let message = _.head(er[Object.keys(er)[0]])
                            this.$notify({
                                title: 'Có lỗi xảy ra',
                                message: message,
                                type: 'warning'
                            })
                        break
                    default:
                        this.$notify.error({
                            title: 'Error',
                            message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                        })
                        break
                  }
                })
            },

            // Xóa câu hỏi
            confirmDeleteModelLesson (model) {
                this.$confirm('Xác nhận xóa câu hỏi: ' + model.text, 'Warning', {
                  confirmButtonText: 'Đồng ý',
                  cancelButtonText: 'Hủy',
                  type: 'warning'
                }).then(() => {
                  this.confirmDeleteModelLessonAction(model)
                }).catch(() => {

                })
            },
            confirmDeleteModelLessonAction (model) {
                axios.delete('questions/' + model.question_id).then(response => {
                  switch (response.code) {
                    case 200:
                        this.$notify({
                            title: 'Thành công',
                            message: 'Xóa bản ghi thành công',
                            type: 'success'
                        })
                        this.fetchQuestionOption();
                      break
                    case 404:
                      this.$notify({
                        title: 'Có lỗi xảy ra',
                        message: 'Không tìm thấy tài nguyên',
                        type: 'warning'
                      })
                      break
                    case 422:
                      let er = response.data.errors
                      let message = _.head(er[Object.keys(er)[0]])
                      this.$notify({
                        title: 'Có lỗi xảy ra',
                        message: message,
                        type: 'warning'
                      })
                      break
                    default:
                      this.$notify.error({
                        title: 'Error',
                        message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                      })
                      break
                  }
                })
            },

            // Xử lý phần cập nhật thông tin đề thi
            submitFormUpdateTestKit (formName) {
                this.canSubmit = false
                let data = {
                    'name': this.modelLessonTestKitUpdate.test_kit_name,
                    'time': this.modelLessonTestKitUpdate.test_kit_time,
                    'score_success': this.modelLessonTestKitUpdate.test_kit_score_success,
                    'content': this.modelLessonTestKitUpdate.test_kit_content,
                    'type_time': this.modelLessonTestKitUpdate.test_kit_type_time,
                }
                axios.put('test-kits/' + this.modelLessonTestKitUpdate.test_kit_id, data).then(response => {
                    this.canSubmit = true
                    switch (response.code) {
                        case 200:
                            this.$notify({
                                title: 'Thành công',
                                message: 'Cập nhật chương mới thành công',
                                type: 'success',
                                duration: '1000'
                            })
                        break
                        case 422:
                            let er = response.data.errors
                            let message = _.head(er[Object.keys(er)[0]])
                        this.$notify({
                            title: 'Có lỗi xảy ra',
                            message: message,
                            type: 'warning'
                        })
                        break
                    default:
                        this.$notify.error({
                            title: 'Error',
                            message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                        })
                        break
                  }
                })
            },

            // Excel
            showImportExcel () {
              this.importExcel.showDialog = true;
              this.importExcel.questions = []
            },

            handleFileUpload () {
              this.importExcel.file = this.$refs.file.files[0]
            },
            async submitFile () {
              this.importExcel.questions = []
              this.importExcel.uploadProcess = true
              let formData = new FormData()
              formData.append('file', this.importExcel.file)
              let response = await axios.post('upload-quiz-online-8192', formData)
              this.importExcel.uploadProcess = false
              if (response.data.status === 1) {
                console.log(this.importExcel.link_quiz)
                this.importExcel.link_quiz = response.data.link_quiz
                this.importExcel.loadingQuizDoc = true
                this.autoLoadQuizDoc()
                this.$notify({
                  title: 'Thành công',
                  message: 'Hệ thống đang thực hiện chuyển đổi file docx. Vui lòng chờ 2-3 phút để hoàn tất ...',
                  type: 'success'
                })
              } else {
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$notify({
                  title: 'Có lỗi xảy ra',
                  message: message,
                  type: 'warning'
                })
              }
            },
            autoLoadQuizDoc () {
              this.importExcel.inteval = setInterval(() => {
                if (this.importExcel.link_quiz) {
                  this.fetchGetQuizOnline0192()
                } else {
                  console.log('Không làm gì cả')
                }
              }, 10 * 1000)
            },
            fetchGetQuizOnline0192 () {
              this.importExcel.loadingQuizDoc = true
              let data = {
                'link_quiz': this.importExcel.link_quiz
              }
              axios.post('get-quiz-online-0192', data).then(response => {
                switch (response.code) {
                  case 200:
                    if (response.data.status === 'success') {
                      this.importExcel.loadingQuizDoc = false
                      this.importExcel.questions = response.data.data
                      clearInterval(this.importExcel.inteval)
                    }
                    break
                  case 422:
                    let er = response.data.errors
                    let message = head(er[Object.keys(er)[0]])
                    this.$notify({
                      title: 'Có lỗi xẳy ra',
                      message: message,
                      type: 'warning'
                    })
                    break
                  default:
                    this.$notify.error({
                      title: 'Error',
                      message: 'Đã có lỗi xảy ra. Vui lòng contact Admin !'
                    })
                    break
                }
              })
            },

            confirmSaveMultiple () {
              this.$confirm('Xác nhận chèn danh sách câu hỏi của file vừa nhập ?', 'Warning', {
                confirmButtonText: 'Đồng ý',
                cancelButtonText: 'Hủy',
                type: 'warning'
              }).then(() => {
                this.confirmSaveMultipleAction()
              }).catch(() => {

              })
            },

            confirmSaveMultipleAction() {
              this.importExcel.canSubmit = false;
              let data = {
                'test_kit_id': this.testkit.test_kit_id,
                'data_question': this.importExcel.questions
              }
              axios.post('questions-save-multiple', data).then(response => {
                this.importExcel.canSubmit = true;
                switch (response.code) {
                  case 200:
                    this.fetchQuestionOption();
                    this.importExcel.showDialog = false
                    this.$notify({
                      title: 'Thành công',
                      message: 'Thêm thành công',
                      type: 'success',
                      duration: '1000'
                    })
                    break
                  case 422:
                    let er = response.data.errors
                    let message = head(er[Object.keys(er)[0]])
                    this.$notify({
                      title: 'Có lỗi xẳy ra',
                      message: message,
                      type: 'warning'
                    })
                    break
                  default:
                    this.$notify.error({
                      title: 'Error',
                      message: 'Đã có lỗi xảy ra. Vui lòng contact Admin !'
                    })
                    break
                }
              })
            }
        },
        watch: {

        }
    }
</script>

<style type="text/css" scoped>
    .main-term {
      background-color: #f2f2f2;
      margin-bottom: 10px;
      margin-top: 10px;
      padding: 5px 10px;
    }
    .main-term .text {
      font-weight: bold;
      font-size: 18px;
      margin-right: 40px;
    }

    .main-term .el-input {
      width: 250px;
      margin-left: 10px;
    }
    .course-terms {
      padding-left: 0px;
      padding-right: 10px;
      margin-bottom: 10px;
    }

    .item-child-2 {
        padding: 2px 0px 2px 5px;
        border: 1px solid rgba(0,0,0,.125);
        line-height: 30px;
    }
    .item-child-2:hover {
        background-color: #f8f8f8;
        cursor: pointer;
    }

    .description-guest {
        font-size: 10px;
        font-style: italic;
        margin-bottom: 7px;
        color: #373636;
    }

    .sub-name {
        font-size: 12px;
        margin-right: 10px;
    }

    .module-testkit {
        margin-right: 10px;
    }
</style>

<!-- Phần Import Excel -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.list-question {
  min-height: 65vh;
}
.item-question {
  margin-bottom: 15px;
}
.index {
  font-size: 18px;
}
.content-question {
  color: green;
  font-weight: bold;
  margin-bottom: 15px;
}
.item-option {
  margin-bottom: 5px;
}
.content-option {
  margin-left: 10px;
}
.item-link {
  margin-left: 10px;
  display: inline-block
}

.updatSeting {
  height: 75vh;
  overflow-y: scroll;
}
</style>

<style type="text/css">
    .mce-panel {
        /*width: 99.5% !important;*/
    }

    .course-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .course-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .course-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 160px;
      height: 115px;
      line-height: 115px !important;
      text-align: center;
    }
    .course-928 {
        width: 160px;
        height: 115px;
        object-fit: cover;
    }
</style>



// WEBPACK FOOTER //
// src/components/courses/TeacherTestKitUpdate.vue